import styled from '@emotion/styled';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  boxShadow,
  BoxShadowProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  shouldForwardProp,
  WithoutCollidingProps,
} from '../../theming';

export interface BaseBodyProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    LayoutProps,
    PositionProps,
    SpaceProps,
    TypographyProps,
    BoxShadowProps {
  overflowScrolling?: string;
  WebkitOverflowScrolling?: string;
}

type NonCollidingBodyProps = WithoutCollidingProps<BaseBodyProps, 'body'>;
type NonCollidingBodyKeys = keyof NonCollidingBodyProps;

export const Body = styled('body', {
  shouldForwardProp: (prop): prop is NonCollidingBodyKeys =>
    shouldForwardProp(prop as NonCollidingBodyKeys),
})<BaseBodyProps>(
  defineWithTheme('bodies'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    space,
    typography,
    boxShadow
  )
);

export type BodyProps = React.ComponentPropsWithoutRef<typeof Body>;
